import { MachineDefect } from 'models/MachineDefect';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const MachineDefectActionType = {
    FETCH_MACHINEDEFECTS: 'FETCH_MACHINEDEFECT',
    FETCH_MACHINEDEFECTS_SUCCESS: 'FETCH_MACHINEDEFECT_SUCCESS',
    ADD_MACHINEDEFECT: 'ADD_MACHINEDEFECT',
    ADD_MACHINEDEFECT_SUCCESS: 'ADD_MACHINEDEFECT_SUCCESS',
    EDIT_MACHINEDEFECT: 'EDIT_MACHINEDEFECT',
    EDIT_MACHINEDEFECT_SUCCESS: 'EDIT_MACHINEDEFECT_SUCCESS',
    DELETE_MACHINEDEFECT: 'DELETE_MACHINEDEFECT',
    DELETE_MACHINEDEFECT_SUCCESS: 'DELETE_MACHINEDEFECT_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMachineDefectsAction {
    type: typeof MachineDefectActionType.FETCH_MACHINEDEFECTS
    payload: ApiPayload,
    returnPayload: MachineDefect[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMachineDefectsAction {
    type: typeof MachineDefectActionType.ADD_MACHINEDEFECT
    payload: ApiPayload,
    returnPayload: MachineDefect,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMachineDefectsAction {
    type: typeof MachineDefectActionType.DELETE_MACHINEDEFECT
    payload: ApiPayload,
    returnPayload: MachineDefect,
    meta: {
        isApiCall: boolean
    },
}

export type IMachineDefectActions = IFetchMachineDefectsAction | IAddMachineDefectsAction | IDeleteMachineDefectsAction

const baseUrl = 'api/machineDefects';
export class MachineDefectActions {
    public static fetchMachineDefects(token: string): IMachineDefectActions {
        return {
            type: MachineDefectActionType.FETCH_MACHINEDEFECTS,
            payload: Api.fetchApiCall(baseUrl, token, MachineDefectActionType.FETCH_MACHINEDEFECTS_SUCCESS, MachineDefectActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMachineDefect(token: string, machineDefect: MachineDefect): IMachineDefectActions {
        return {
            type: MachineDefectActionType.ADD_MACHINEDEFECT,
            payload: Api.postApiCall(baseUrl, token, MachineDefectActionType.ADD_MACHINEDEFECT_SUCCESS, MachineDefectActionType.API_ERROR, machineDefect),
            returnPayload: MachineDefect.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editMachineDefect(token: string, machineDefect: MachineDefect): IMachineDefectActions {
        return {
            type: MachineDefectActionType.EDIT_MACHINEDEFECT,
            payload: Api.putApiCall(baseUrl + '/' + machineDefect.id, token, MachineDefectActionType.EDIT_MACHINEDEFECT_SUCCESS, MachineDefectActionType.API_ERROR, machineDefect),
            returnPayload: MachineDefect.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMachineDefect(token: string, id: number): IMachineDefectActions {
        return {
            type: MachineDefectActionType.DELETE_MACHINEDEFECT,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MachineDefectActionType.DELETE_MACHINEDEFECT_SUCCESS, MachineDefectActionType.API_ERROR, true),
            returnPayload: MachineDefect.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
